import { RouteRecordRaw } from "vue-router";

import usePermissions from "@/hooks/use-permissions";
import SegmentFormPage from "@/pages/games/GameDisplay/children/segments/SegmentForm/SegmentFormPage.vue";
import SegmentsListPage from "@/pages/games/GameDisplay/children/segments/SegmentsList/SegmentsListPage.vue";

import links from "./links";

const { canReadSegments, canWriteSegments } = usePermissions();

export default <RouteRecordRaw[]>[
  {
    path: "new",
    component: SegmentFormPage,
    name: links.games.segments.new,
    props: true,
    meta: {
      title: "New segment",
      permission: canWriteSegments,
    },
  },
  {
    path: ":segmentId/edit",
    component: SegmentFormPage,
    name: links.games.segments.edit,
    props: true,
    meta: {
      title: "Edit segment",
      permission: canWriteSegments,
    },
  },
  {
    path: ":segmentId/duplicate",
    component: SegmentFormPage,
    name: links.games.segments.duplicate,
    props: (route) => ({ ...route.params, duplicate: true }),
    meta: {
      title: "Duplicate segment",
      permission: canWriteSegments,
    },
  },
  {
    path: ":segmentId/preview",
    component: SegmentFormPage,
    name: links.games.segments.preview,
    props: (route) => ({ ...route.params, preview: true }),
    meta: {
      title: "Preview segment",
      permission: canReadSegments,
    },
  },
  {
    path: "",
    component: SegmentsListPage,
    name: links.games.segments.list,
    props: true,
    meta: {
      title: "Segments",
      permission: canReadSegments,
    },
  },
];
